import { Clip } from '@goldcast/player-config/src/types/clip-types';
import ContentDialog from '@/Pages/Sessions/uiComponents/ContentDialog/ContentDialog';
import { useAllVisibleClips } from '@/hooks/useAllVisibleClips';
import ClipsListItem from '@/Pages/ClipsListPage/ClipsListItem';

export default function ClipListModal({
  isOpen,
  onClose,
  onClipSelection
}: {
  isOpen: boolean;
  onClose: () => void;
  onClipSelection: (clip: Clip) => void;
}) {
  // Read through the scoped selector rather than the store directly: the store also holds highlight
  // reels, which aren't attachable to a post.
  const { allVisibleClips } = useAllVisibleClips();

  return (
    <ContentDialog isOpen={isOpen} size="medium" setIsOpen={onClose} disableBackdropClose={true}>
      {allVisibleClips.map((clip: Clip) => (
        <div key={clip.asset_metadata.id}>
          <ClipsListItem clip={clip} onClipSelect={onClipSelection} isCollapsed={false} />
        </div>
      ))}
    </ContentDialog>
  );
}
